<template>
<div class="w-100 h-100 bg-cover p-relative" :style="{backgroundImage: 'url('+ bgStyle +')'}">
  <h2 class="d-md-none mobile-section-title text-white">ONLINE STORE</h2>
  <div class="container pl-6 pt-6 h-100 text-white">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
      <div>
        <h2 class="font-size-2_5rem tracking-1 text-center mb-5 d-none d-md-block">ONLINE STORE</h2>
        <a href="https://lesillage.thebase.in" target="_blank" class="btn btn-layered px-5">
          <span>LE SILLAGE<br>official onlineStore</span>
          LE SILLAGE<br>official onlineStore          
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import bg from '@/assets/images/bg-onlineshop.jpg'
// import bg2x from '@/assets/images/bg-onlineshop@2x.jpg'

export default {
  computed: {
    bgStyle() {
      return bg
    }
  }
}
</script>

<style lang="scss" scoped>

</style>